import './default.scss';
import styled from 'styled-components';

export const div_ListingVTInfo = styled.div`
	//DEFAULT
	width: 100%;
`;
export const div_ListingVT = styled.div`
	//DEFAULT
	width: 100%;
`;
